import React, { useEffect } from 'react';
import { useSecurity } from '../useSecurity';

interface InjectedProps {
  history: History | any;
}

type Props = InjectedProps;

const CallbackPage: React.FC<Props> = ({ history }) => {
  const { userManager, log } = useSecurity();
  useEffect(() => {
    const hash = window.location.hash;
    log(['silentCallback', hash]);
    userManager
      .signinRedirectCallback()
      .then((user) => {
        log(['silentCallback::Callback-OK', user]);
        if (user) {
          let nextUrl = user.state.replace(process.env.PUBLIC_URL, '');
          log(['silentCallback::Callback-FW', nextUrl]);
          if (nextUrl === '/callback') nextUrl = '.';
          window.history.replaceState({}, document.title, nextUrl || '.');
          history.push(nextUrl);
        } else {
          log(['silentCallback::Callback-EMPTYUSER']);
        }
      })
      .catch((err) => {
        log(['silentCallback::Callback-Error', err]);
        window.history.replaceState({}, document.title, '.');
        history.push('.');
      });
  }, []);
  return <></>;
};

export default CallbackPage;
